enum GlobalInformation {
  hostingURL = "https://app-tau-six.vercel.app",
}

export { GlobalInformation };
